import { Type } from 'react-bootstrap-table2-editor';
import * as Helpers from '../Helpers/DatatableHelpers';
import store from '../../../../../store';
import { addTemplateError, getTemplateRelatedMarkingTeams, clearUpdateTemplateErrors } from '../../../../../Redux/Actions/Contract.Templates.Actions';

const ContractTemplates = () => [
	{
		dataField: 'id',
		text: 'Node ID',
		sort: true,
		editable: false,
		headerClasses: 'th-td-sm'
	},
	{
		dataField: 'name',
		text: 'Template Name',
		sort: true,
		editable: false,
		headerClasses: 'th-title-td',
		formatter: (cell, row) => Helpers.formatName(cell, row),
		csvFormatter: (cell, row) => Helpers.formatName(cell, row)
	},
	{
		dataField: 'spareField1',
		text: 'Field 1',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 1: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField2',
		text: 'Field 2',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 2: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField3',
		text: 'Field 3',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 3: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField4',
		text: 'Field 4',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 4: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField5',
		text: 'Field 5',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 5: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField6',
		text: 'Field 6',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 6: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField7',
		text: 'Field 7',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 7: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField8',
		text: 'Field 8',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 8: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField9',
		text: 'Field 9',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 9: ${validated.message}`));
			return validated;
		}
	},
	{
		dataField: 'spareField10',
		text: 'Field 10',
		sort: true,
		headerClasses: 'th-td-md',
		editable: (content, row, rowIndex, columnIndex) => Helpers.setEditableAsPerArchive(content, row, rowIndex, columnIndex),
		validator: newVal => {
			let validated = Helpers.fieldLengthValidation(newVal);
			if (!validated.valid) store.dispatch(addTemplateError(`Spare Field 10: ${validated.message}`));
			return validated;
		}
	},
    {
        dataField: 'qualYear',
        text: 'Qualification year',
        sort: true,
        headerClasses: 'th-td-md',
        editable: false,
    },
    {
		dataField: 'version',
		text: 'Version',
		sort: true,
		editable: false,
		headerClasses: 'th-td-sm'
	},
	{
		dataField: 'archive',
		text: 'Status',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		editor: {
			type: Type.CHECKBOX,
			value: 'Archived:Active'
		},
		validator: async (newValue, row, column, done) => {
			if (newValue === 'Archived') {
				await store.dispatch(getTemplateRelatedMarkingTeams(row.id));
				if (row.isValidForArchive === false) {
					store.dispatch(addTemplateError(`Template ID ${row.id} is assigned to Teams: ${row.invalidArchiveMessage}`));
					return done({
						valid: false,
						message: 'Template is assigned to Teams'
					});
				} else return done();
			} else {
				if (row.isValidForArchive === false) {
					store.dispatch(clearUpdateTemplateErrors());
				}
				return done();
			}
		}
	}
];

export default ContractTemplates;
